import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService, HttpRequestModel } from 'src/app/service/httpservice/http.service';
import { ToolSearchParams } from 'src/app/shared/models/toolSearchParams';
import { buildQueryString } from 'src/app/utils/functions';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService {
  HttpRequestModel: HttpRequestModel = new HttpRequestModel();

  constructor(private httpService: HttpService) {}

  private defaultParams: ToolSearchParams = {
    page: 1,
    limit: 1000,
    search: '',
    fields: '',
    order: 'toolId,DESC',
  };
  defaultShopParams: ToolSearchParams = {
    page: 1,
    limit: 1000,
    search: '',
    fields: '',
  };

  private activeEmployees = {
    order: 'employee_alias ASC', // this format is not wrong, it is using v1 endpoints
    status: '1',
  };

  private embedAssignment: {
    attributes: 'type.name';
    embed: 'responsibleParty,employee,foreman,owner,facility,vendor,department';
  };

  private dataParams: ToolSearchParams = {
    ...this.defaultParams,
    order: 'name,asc',
  };

  private enableDataParams: ToolSearchParams = {
    ...this.defaultParams,
    search: 1,
    fields: 'enabled',
    order: 'name,asc',
  };

  private embedAssetClass = {
    embed: 'assetClass',
  };

  private jobParams = {
    attributes: 'jobNumber,name',
    order: 'name,ASC',
  };

  private assignmentParams = {
    embed: 'responsibleParty,employee,owner,job,facility,vendor,department,type',
  };
  private batchIdParams = {
    attributes: ['batchId'],
    group: ['batchId'],
    order: ['batchId', 'DESC'],
  };

  private assignmentFilterParams = {
    limit: 100000,
    embed: 'assignment',
  };

  // READ endpoints
  read = {
    'employee-types': (params: ToolSearchParams = {}): Observable<any> =>
      this.postRequest('GET', `employee_titles`, {
        ...params,
      }),
    attributes: (params: ToolSearchParams = {}): Observable<any> =>
      this.postRequest('GET', `jobpointe/job_board_attributes`, {
        ...params,
      }),
  };

  // CREATE endpoints
  create = {
    attributes: (payload: any = {}): Observable<any> =>
      this.postRequest('POST', `jobpointe/job_board_attributes`, payload),
    'employee-types': (payload: any = {}): Observable<any> => this.postRequest('POST', `employee_titles`, payload),
  };

  // UPDATE endpoints
  update = {
    'employee-types': (payload: any = {}): Observable<any> =>
      this.postRequest('PUT', `employee_titles/${payload.id}`, payload.data),
    attributes: (payload: any = {}): Observable<any> =>
      this.postRequest('PUT', `jobpointe/job_board_attributes/${payload.id}`, payload.data),
  };

  // ENABLE/DISABLE status
  status = {
    'employee-types': (payload: any): Observable<any> =>
      this.postRequest('PATCH', `employee_titles/${payload.id}`, {
        status: payload.status,
      }),
    attributes: (payload: any): Observable<any> =>
      this.postRequest('PATCH', `jobpointe/job_board_attributes/${payload.id}`, {
        status: payload.status,
      }),
  };

  // DELETE endpoints
  delete = {
    'employee-types': (id: number): Observable<any> => this.postRequest('DELETE', `employee_titles/${id}`),
    attributes: (id: number): Observable<any> => this.postRequest('DELETE', `jobpointe/job_board_attributes/${id}`),
  };

  private postRequest(
    requestType: string,
    url: string,
    data: any = '',
    showLoader: boolean = false,
    hideLoader: boolean = false,
  ): Observable<any> {
    // if GET request and param data was received, format query string and reset data to be sent in body
    if (requestType === 'GET' && data) {
      const queryString = buildQueryString(data);
      url += queryString;
      data = '';
    }

    this.HttpRequestModel.reset();
    this.HttpRequestModel.method = requestType;
    this.HttpRequestModel.url = url;
    this.HttpRequestModel.body = data;
    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }
}
